export default __webpack_public_path__ + "static/media/IMG_20210709_111854_894.8d1bc9e5.jpg";